export const ieo = {
  zzjx: "進行中",
  rgjl: "サブスクリプションレコード",
  yjjs: "もう終わりだよ",
  sf: "最初のリリース",
  mjze: "調達総額",
  ckjz: "スケジュール",
  tips_1:
    "Biking Startup プラットフォームが開始されました。Biking で富のコードを発見しましょう!",
  tips_2: "高品質なプロジェクトが間もなく開始されますので、お楽しみに",
  jyjjks: "まもなく開始します",
  ksjy: "始める",
  qjy: "取引に行く",
  xmmc: "プロジェクト名",
  xmfjs: 'プロジェクトパーティーのご紹介',
  syxm: "すべてのプロジェクト",
  banner_1: "新しく立ち上げられたブロックチェーンプロジェクト立ち上げプラットフォーム",
  banner_2:
    "Biking 一緒にブロックチェーンのダークホースを見つけて、富の自由への道を歩み始めましょう",
  ywc: "完了",
  rgsj: "サブスクリプション時間:",
  zcz: "サポーター",
  dqjd: "現在の進行状況",
  yck: "盛り上がった",
  sddb: "トークンを受信しました",
  dff: "発行予定",
  zwxm: "まだプロジェクトがありません",
  xq: "詳細",
  wksyr: "予熱が開始されていません",
  yrz: "予熱",
  jxz: "進行中",
  yjs: "終了",
  ts: "プロンプト",
  dbwfjy: "このトークンは一時的に取引できません",
  ckqtdb: "他のトークンを確認してください",
  xm: "プロジェクト",
  ksrg: "サブスクリプションを開始",
  yrg: "購読済み",
  xmjs: "プロジェクトの紹介",
  csjg: "初期価格",
  dbzl: "トークンの合計量: {amount}個",
  cssz: "初期市場価格: {fdv} 米ドル",
  xmcytj: "プロジェクト参加条件",
  cjygzh: "Biking アカウントを作成する",
  yyzh: "すでにアカウントをお持ちなので、直接ログインしてください",
  dlzhjkcy:
    "サブスクリプションに参加するには、アカウントにログインしてください",
  dljkrg: "購読するにはアカウントにログインしてください",
  xhzc: "スポット アセット",
  zcdy: "スポット資産 ≥ 10 USDT",
  rggz: "サブスクリプション ルール",
  rgcg: "サブスクリプションが成功しました",
  cgrgxm: "おめでとうございます！ プロジェクトのサブスクライブが完了しました。",
  fhsy: "ホームページに戻る",
  cyrghd: "Biking Startup のサブスクリプション アクティビティに参加する",
  rgje: "サブスクリプション金額",
  xhzcgz: "スポット資産評価",
  rgsm: "サブスクリプションの説明:",
  rgsm1: "1. 個々のサブスクリプション金額は ≥{amount1}USDT; ≤{amount2}USDT;",
  rgsm2:
    "2. プロジェクトは出資比率に応じて均等な割合でサブスクリプションを割り当てます。ユーザーが実際の割り当て額を超える量のトークンをサブスクライブした場合、サブスクリプション完了後、残りの U は現金に返されます。アカウント",
  qd: "わかりました",
  dyr: "予熱する",
  rgdjs: "サブスクリプション",
  yrdjs: "予熱カウントダウン",
  jykqdjs: "トランザクション開始までのカウントダウン",
  qrg: "購読に移動",
  rgjebdy: "サブスクリプション金額は少なくとも {amount} USDT です",
  rgjebgy: "サブスクリプションの最大金額は {amount} USDT を超えてはなりません",
  rgjeccdqjc: "サブスクリプション額が現在の資産額を超えています",
  fxts1: "1. スタートアップ プロジェクトはまだ初期段階にあり、プロジェクトの運営、プロジェクトの基礎となる技術、法規制環境などに大きなリスクが存在する可能性があります。",
  fxts2: "2. トークンを理解し、その固有のリスクを評価するには、高度な技術的および財務的知識が必要です。",
  fxts3: "3. テクノロジー、法規制、市場およびその他の要因の影響を受け、購入したトークンの価格は激しく変動し、価格が大幅に下落または上昇する可能性があります。",
  fxts4: "4. トークンまたは BIKING 取引プラットフォームの基礎となるテクノロジーにより、購入したトークンは完全または部分的に引き出すことができない場合があります。",
  sfpt: "ブロックチェーンプロジェクト立ち上げプラットフォーム",
  xmhzsq: "プロジェクト協力",
  hdlx: "タイプ",
  yryq: "1 つの記号",
  yrdq: "複数の署名",
  hdjg: "価格",
  hdsl: "数量",
  zqs: "署名の総数",
  rgqs: "サブスクリプションチケットの数",
  rgsl: "サブスクリプション数量",
  mqsl: "署名ごとの数量",
  mrzgqs: "署名の最大数",
  qian: "サイン",
  lian: "チェーン",
  hdrgsm: "サブスクリプションの手順: 宝くじに当選した後、当選したユーザーの総数はすべての当選ユーザーに基づいてランダムに選択されます。サブスクリプションが失敗した場合、失敗したサブスクリプションで使用された USDT は、当選したエアドロップが発行されたときに返されます。" ,
  jqqd: "優勝結果を楽しみにしています",
  dbffkjy: "トークンは発行後に取引できます",
  dzjgb: "発表予定",
  dzq: "勝つために",
  ffzt: "配布状況",
  dbff: "勝利トークンの発行",
  yff: "発行済み",
  wzq: "勝てませんでした",
};



// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/ja_JP.js